import { Component, OnDestroy, OnInit } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faChartSimple,
  faCode,
  faSquarePollVertical,
} from '@fortawesome/free-solid-svg-icons';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  homeComponents: any[] = [];
  private header: HTMLElement | null = document.querySelector('.navbar');
  language!: string;
  routeSub!: Subscription;
  icons: { [key: string]: IconProp } = {
    faChartSimple: faChartSimple,
    faCode: faCode,
    faSquarePollVertical: faSquarePollVertical,
    faConnectdevelop: faConnectdevelop,
  };

  constructor(
    private route: ActivatedRoute,
    private metaTagService: MetaTagService
  ) {
    if (window.scrollY > 30) {
      this.header?.classList.add('scrolled');
    } else {
      this.header?.classList.remove('scrolled');
    }
    window.onscroll = () => {
      if (this.header) {
        if (window.scrollY > 30) {
          this.header.classList.add('scrolled');
        } else {
          this.header.classList.remove('scrolled');
        }
      }
    };
  }

  ngOnInit() {
    this.language = this.route.snapshot.url[0].path;

    this.routeSub = this.route.params.subscribe((params) => {
      if (params['lang']) {
        this.language = params['lang'];
        this.getResolverData();
      }
    });
    this.getResolverData();
  }

  getResolverData() {
    const resolverData = this.route.snapshot.data['homeData'];
    if (resolverData) {
      this.homeComponents = resolverData.homeComponents;
      this.metaTagService.updateMetaTags(resolverData.metadata.meta);
    } else {
      console.error('Resolver data is undefined');
    }
  }

  ngOnDestroy() {
    this.header?.classList.add('scrolled');
    window.onscroll = null;
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
